module.exports = __webpack_public_path__ + "img/23.e86866d6.webp";